var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-overlay d-md-none",on:{"click":function($event){return _vm.closeSidebar()}}})}
var staticRenderFns = []

export { render, staticRenderFns }